import { Col, Input, Radio, Row } from "antd";

import qitaf from "../../../styles/images/qitaf.png";
import rajhi from "../../../styles/images/rajhi.png";
import visa from "../../../styles/images/visa.svg";
import { useEffect, useMemo, useState } from "react";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import { showNotitfication } from "../../../utils/Utils";
import { toAddCoupon } from "../../../apis/actions/appointments.actions";
import {
  toAddShop,
  toRemoveCoupon,
} from "../../../apis/actions/service.actions";

import { useNavigate } from "react-router-dom";
import {
  resetState,
  setAmountToDisplay,
  setCoupon,
  setDiscountAmount,
  setLoyaltyPhone,
  setLoyaltyType,
  setWalletAmount,
} from "../../../apis/slices/globalSlice";
import useIsConnected from "../../../utils/IsConnected";
import { useTranslation } from "react-i18next";
import DonationSection from "../../../Components/donation/DonationSection";
import { BiTrash } from "react-icons/bi";
import loayl from "../../../assets/loyal.png";
import { Select } from "antd";
import {
  getGrandPayableTotal,
  parseShopCheckoutTotals,
  resolveOrderBaseAmount,
} from "../../../utils/paymentTotals";
import { cancelCartAddedFeedback } from "../../../utils/cartAddedFeedback";
const { Option } = Select;
interface Props {
  /** Grand total actually charged (order + donation − wallet); passed to cart checkout when provided. */
  toSave: (payableTotal: number) => void;
  btnTitle: string;
}

const Payment = ({ toSave, btnTitle }: Props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isConnected = useIsConnected();
  const dispatch = useDispatch<AppDispatch>();

  const [disableCoupon, setDisableCoupon] = useState(false);
  const { profil } = useSelector((state: RootState) => state?.login);

  const {
    cart_id,
    my_cart,
    loyaltyType,
    services,
    products,
    appointment,
    walletAmount,
    donationAmount,
    amount,
    coupon,
    discountAmount,
    cartReady,
    cartLoading,
    cartError,
  } = useSelector((state: RootState) => state?.global);

  const validateCoupon = async (value: string) => {
    if (!isConnected) {
      navigate("/login");
      return;
    }
    const json: any = { cart_id: cart_id };
    if (value !== "") {
      json.coupon = value;
    }
    const res: any = await dispatch(toAddCoupon(json));
    const resultat = res.payload?.data.result;
    if (resultat?.code === 200) {
      setDisableCoupon(true);
      showNotitfication(resultat.message, "success");
      const totals = parseShopCheckoutTotals(resultat);
      if (totals) {
        dispatch(
          setAmountToDisplay(
            resolveOrderBaseAmount(
              totals.orderAmount,
              services,
              products,
              totals.discountAmount
            )
          )
        );
        dispatch(
          setDiscountAmount(
            totals.discountAmount > 0
              ? totals.discountAmount.toFixed(2)
              : 0
          )
        );
      }
      dispatch(setCoupon(json.coupon));
      if (resultat?.order_amount === 0) {
        navigate("/profile");
        dispatch(resetState());
      }
    } else {
      showNotitfication(resultat.message, "error");
    }
  };

  const orderBaseAmount = useMemo(
    () =>
      resolveOrderBaseAmount(
        amount,
        services,
        products,
        discountAmount
      ),
    [amount, services, products, discountAmount]
  );

  const payableTotal = useMemo(
    () =>
      getGrandPayableTotal(orderBaseAmount, donationAmount, walletAmount),
    [orderBaseAmount, donationAmount, walletAmount]
  );

  /** Keep Redux `amount` aligned with catalog/API net (avoids stale gross after `toAddShop`). */
  useEffect(() => {
    if (!Number.isFinite(orderBaseAmount) || orderBaseAmount < 0) return;
    const stored = Number(amount);
    if (!Number.isFinite(stored) || Math.abs(stored - orderBaseAmount) > 0.02) {
      dispatch(setAmountToDisplay(orderBaseAmount));
    }
  }, [amount, orderBaseAmount, dispatch]);

  const orderAmountNum = orderBaseAmount;
  const earnedPoints = Math.floor(orderAmountNum * 6);
  const earnedQitafPOints = Math.floor(orderAmountNum);
  const qitafearned =
    earnedQitafPOints < 20
      ? 0
      : earnedPoints >= 20 && earnedPoints <= 39
      ? 1
      : Math.floor(earnedQitafPOints / 20);

  const loyaltyPoints = Math.floor(earnedQitafPOints / 10);
  const loyaltyOptions = [
    {
      value: "autochapeau",
      label: "AutoChapeauPoints",
      icon: loayl,
      messages: [],
    },
    {
      value: "qitaf",
      label: "qitaf",
      icon: qitaf,
      messages: [
        i18n.language === "ar"
          ? `ستضاف النقاط إلى ${profil?.data?.phone || "رقم الهاتف"}`
          : `The points will be added to ${
              profil?.data?.phone || "phone number"
            }`,
        i18n.language === "ar"
          ? `ستكسب ${qitafearned} نقطة قطاف`
          : `You will earn ${qitafearned} qitaf points`,
      ],
    },
    {
      value: "alrajhi",
      label: "rajhi",
      icon: rajhi,
      messages: [
        i18n.language === "ar"
          ? `ستضاف النقاط إلى ${profil?.data?.phone || "رقم الهاتف"}`
          : `The points will be added to ${
              profil?.data?.phone || "phone number"
            }`,
        i18n.language === "ar"
          ? `ستكسب ${earnedPoints} نقطة مكافأة`
          : `You will earn ${earnedPoints} mokafaa points`,
      ],
    },
  ];
  const handleRemoveCoupon = async () => {
    if (!isConnected) {
      navigate("/login");
      return;
    }

    const payload: any = { cart_id, coupon };

    const res: any = await dispatch(toRemoveCoupon(payload));
    const result = res?.payload?.data?.result;

    if (result?.code === 200) {
      showNotitfication(
        i18n.language === "ar"
          ? "تمت إزالة كوبون الخصم بنجاح"
          : "Coupon removed successfully",
        "success"
      );
      dispatch(setDiscountAmount(0));
      dispatch(setCoupon(""));
      setDisableCoupon(false);
      const totals = parseShopCheckoutTotals(result);
      if (totals) {
        dispatch(
          setAmountToDisplay(
            resolveOrderBaseAmount(
              totals.orderAmount,
              services,
              products,
              totals.discountAmount
            )
          )
        );
      }
    } else {
      showNotitfication(result?.message || "Failed to remove coupon", "error");
    }
  };

  const formatAmount = (num: number) => {
    if (!Number.isFinite(num)) return "0.00";
    return num.toFixed(2);
  };

  const handlePayClick = async () => {
    if (!cartReady || cartLoading || cartError) return;
    if (!isConnected) {
      navigate("/login");
      return;
    }

    let orderAmount = orderBaseAmount;
    if (
      services.length === 0 &&
      products.length > 0 &&
      cart_id &&
      my_cart?.cart_id
    ) {
      try {
        const payload = await dispatch(
          toAddShop({
            ...my_cart,
            coupon: coupon || null,
          })
        ).unwrap();
        const result = payload?.data?.result;
        const totals = parseShopCheckoutTotals(result);
        if (totals) {
          orderAmount = resolveOrderBaseAmount(
            totals.orderAmount,
            services,
            products,
            totals.discountAmount
          );
          dispatch(setAmountToDisplay(orderAmount));
          dispatch(
            setDiscountAmount(
              totals.discountAmount > 0
                ? totals.discountAmount.toFixed(2)
                : 0
            )
          );
        }
      } catch (err) {
        cancelCartAddedFeedback();
        console.error("toAddShop failed:", err);
        return;
      }
    }

    const payable = getGrandPayableTotal(
      orderAmount,
      donationAmount,
      walletAmount
    );
    toSave(payable);
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          <hr className="ac--summary-divider" />
        </Col>
      </Row>
      {Number(discountAmount) > 0 && (
        <>
          <Row gutter={16} style={{ marginTop: "1rem" }}>
            <Col span={20}>
              <BiTrash
                className="ac--pointer ac--summary-item"
                size={14}
                onClick={handleRemoveCoupon}
              />{" "}
              <span className="ac--summary-title">
                {t("profile.order.cart.discount_amount")}
              </span>
            </Col>
            <Col span={4} style={{ textAlign: "right", paddingRight: "15px" }}>
              <span className="ac--summary-title  icon-saudi_riyal">
                {discountAmount}
                {/* {t("profile.currency")}*/}
              </span>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <hr className="ac--summary-divider" />
            </Col>
          </Row>
        </>
      )}
      {walletAmount > 0 && (
        <>
          <Row gutter={16} style={{ marginTop: "1rem" }}>
            <Col span={20}>
              <BiTrash
                className="ac--pointer ac--summary-item"
                size={14}
                onClick={() => dispatch(setWalletAmount(0))}
              />{" "}
              <span className="ac--summary-title">
                {t("partial_payment.amountPayed")}
              </span>
            </Col>
            <Col span={4} style={{ textAlign: "right", paddingRight: "15px" }}>
              <span className="ac--summary-title  icon-saudi_riyal">
                {walletAmount}
                {/* {t("profile.currency")}*/}
              </span>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <hr className="ac--summary-divider" />
            </Col>
          </Row>
        </>
      )}
      <Row gutter={16} style={{ marginTop: "1rem" }}>
        <Col span={19}>
          <span className="ac--summary-title">
            {t("profile.order.cart.total")}
            <br />
            <p className="ac--font-expo" style={{ fontSize: "14px" }}>
              ({t("profile.order.cart.vat")})
            </p>
          </span>
        </Col>
        <Col span={5} style={{ textAlign: "right", paddingRight: "25px" }}>
          <span className="ac--summary-title  icon-saudi_riyal">
            {formatAmount(payableTotal)}
            {/*{t("profile.currency")}*/}
          </span>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <hr className="ac--summary-divider" />
        </Col>
      </Row>

      <Row gutter={16} className="mt-5 ">
        <Col
          xxl={17}
          xl={17}
          md={15}
          lg={15}
          xs={11}
          sm={11}
          style={{ padding: "0" }}
        >
          <Input
            className="ac--coupon-input "
            disabled={
              (appointment === null && services.length > 0) || disableCoupon
            }
            placeholder={t("profile.order.cart.coupon")}
            value={coupon}
            onChange={(e) => dispatch(setCoupon(e.target.value))}
          ></Input>
        </Col>
        <Col
          xxl={1}
          xl={1}
          md={1}
          lg={1}
          xs={1}
          sm={1}
          style={{ padding: "0" }}
        ></Col>
        <Col
          xxl={6}
          xl={6}
          md={8}
          lg={8}
          xs={12}
          sm={12}
          style={{ padding: "0" }}
        >
          <button
            className="btn ac--btn-primary-jflatbold"
            onClick={() => validateCoupon(coupon)}
            style={{ display: "flex", justifyContent: "center" }}
            disabled={
              (appointment === null && services.length > 0) ||
              coupon === "" ||
              disableCoupon
            }
          >
            {t("profile.order.cart.verify")}
          </button>
        </Col>
      </Row>
      <DonationSection />

      <Row gutter={16} className="mt-20">
        <Col
          span={24}
          style={{ paddingTop: "0.7rem", paddingBottom: "0.7rem" }}
        >
          <span className="ac--summary-title">
            {t("profile.order.cart.gainLoyalty")}
          </span>
        </Col>
        <Col span={24}>
          <Select
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            style={{ width: "100%" }}
            value={loyaltyType}
            onChange={(value) => {
              dispatch(setLoyaltyType(value));
            }}
            className="ac--coupon-input ac--font-expo"
            dropdownRender={(menu) => (
              <div style={{ width: "100%" }}>{menu}</div>
            )}
          >
            {loyaltyOptions.map((option) => {
              // Format messages with styling
              const formattedMessages = option.messages.map(
                (message, index) => {
                  if (index === 0) {
                    // Phone number line
                    return message.replace(
                      profil?.data?.phone ||
                        (i18n.language === "ar"
                          ? "رقم الهاتف"
                          : "phone number"),
                      `<strong dir="ltr">${
                        profil?.data?.phone ||
                        (i18n.language === "ar" ? "رقم الهاتف" : "phone number")
                      }</strong>`
                    );
                  } else {
                    // Points line
                    const pointsValue =
                      option.value === "qitaf" ? qitafearned : earnedPoints;
                    const pointsText =
                      i18n.language === "ar"
                        ? `نقطة ${option.value === "qitaf" ? "قطاف" : "مكافأة"}`
                        : `${
                            option.value === "qitaf" ? "qitaf" : "mokafaa"
                          } points`;
                    return message.replace(
                      pointsValue +
                        (i18n.language === "ar" ? " " : " ") +
                        pointsText,
                      `<strong style="color: ${
                        option.value === "qitaf" ? "#800080" : "#0000FF"
                      }">${pointsValue} ${pointsText}</strong>`
                    );
                  }
                }
              );

              const label = (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {option.icon && (
                    <img
                      src={option.icon}
                      alt={option.label}
                      style={{ width: 20, marginRight: 8 }}
                    />
                  )}
                  <span>
                    {t(`payment.${option.label}`)}{" "}
                    {option.value === "autochapeau" &&
                      loyaltyPoints > 0 &&
                      `( ${loyaltyPoints} )`}
                  </span>
                </div>
              );

              return (
                <Option key={option.value} value={option.value} label={label}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "70%",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {option.icon && (
                        <img
                          src={option.icon}
                          alt={option.label}
                          style={{
                            width: 20,
                            marginRight: i18n.language == "en" ? 8 : 0,
                            marginLeft: i18n.language === "ar" ? 8 : 0,
                          }}
                        />
                      )}
                      <span>
                        {t(`payment.${option.label}`)}{" "}
                        {option.value === "autochapeau" &&
                          loyaltyPoints > 0 &&
                          `( ${loyaltyPoints} )`}
                      </span>
                    </div>

                    {option.messages.length > 0 && (
                      <div
                        className="ac--font-expo"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          fontSize: "12px",
                          color: "#666",
                          maxWidth: "60%",
                          lineHeight: "1.5",
                        }}
                      >
                        {formattedMessages.map((html, index) => (
                          <div
                            key={index}
                            dangerouslySetInnerHTML={{ __html: html }}
                            className="ac--font-expo"
                            style={{
                              textAlign:
                                i18n.language === "ar" ? "right" : "left",
                              fontWeight: "normal",
                              marginRight: i18n.language == "en" ? 10 : 0,
                              marginLeft: i18n.language === "ar" ? 10 : 0,
                            }}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </Option>
              );
            })}
          </Select>
        </Col>
      </Row>

      <button
        className="btn ac--btn-primary-jflatbold mt-30"
        disabled={!cartReady || cartLoading || Boolean(cartError) || (appointment === null && services.length > 0)}
        type="button"
        onClick={() => void handlePayClick()}
      >
        {t("profile.order.cart.pay")} (
        <span className="icon-saudi_riyal" />
        {formatAmount(payableTotal)}
        )
      </button>
    </>
  );
};

export default Payment;
